<template>
  <page-template type="norightpanel" class="comptes new">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" title="Ajouter un compte" linkback="/comptes" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div>
          <v-form class="form-new-element">
            <v-container>
              <v-text-field v-model="account.society" label="Société" outlined></v-text-field>
              <v-text-field v-model="account.lastName" label="Nom" outlined></v-text-field>
              <v-text-field v-model="account.firstName" label="Prénom" outlined></v-text-field>
              <v-text-field v-model="account.email" label="Email" outlined></v-text-field>
              <h2>Mot de passe</h2>
              <v-btn @click="generate()" class="my-4 mx-0 primary-button outlined">Générer un mot de passe</v-btn>
              <v-text-field outlined disabled v-model="account.password" ></v-text-field>
              <h2>Envoyer une notification au compte</h2>
              <v-checkbox v-model="checkbox" label="Envoyer un e-mail à la personne à propos de son compte." ></v-checkbox>
              <v-select v-model="account.function" :items="functions" label="Rôle" outlined></v-select>
              <v-btn @click="save(true)" class="mt-4 justify-center primary-button">Ajouter un compte</v-btn>
            </v-container>
          </v-form>
        </div>
      </div>
    </template>
  </page-template>
</template>

<style lang="scss">
    .comptes.new{
        .form-new-element{
            width: 75%;
            h2{
                padding: 0 1rem;
            }
        }
    }
</style>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'ComptesNew',
    components: { pageTemplate, toolBar },
    data: () => {
      return {
        checkbox: true,
        characters: 'a-z,A-Z,0-9,#',
        size: 15,
        account: {
          society: '',
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          function: '',
          ambassador: false
        },
        functions: ['Administrateur', 'Propriétaire', 'Agence']
      }
    },
    methods: {
      generate () {
        const charactersArray = this.characters.split(',')
        let CharacterSet = ''
        let password = ''
        if (charactersArray.indexOf('a-z') >= 0) {
          CharacterSet += 'abcdefghijklmnopqrstuvwxyz'
        }
        if (charactersArray.indexOf('A-Z') >= 0) {
          CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        }
        if (charactersArray.indexOf('0-9') >= 0) {
          CharacterSet += '0123456789'
        }
        if (charactersArray.indexOf('#') >= 0) {
          CharacterSet += '![]{}()%&*$#^<>~@|'
        }
        for (let i = 0; i < this.size; i++) {
          password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length))
        }
        this.password = password
      },
      // SAVE NEW ADMIN USER
      async save (isDraft) {
        this.$store.dispatch('loading')
        try {
            this.account.admin = isDraft
            await axios.post(`${apiURL}/auth/registration`, this.account)
            this.$router.push('/comptes')
        } catch (e) {
            alert('Une erreur est survenue, veuillez réessayer.')
            console.log(e)
        } finally {
            this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>